module.exports = __webpack_public_path__ + "img/no-results-empty-state.6fe0c0aa.svg";